import React from 'react';
import { Box, FormControlLabel, Radio, RadioGroup as MuiRadioGroup } from '@mui/material';

interface Option {
  value: string | number;
  label: React.ReactNode;
}

interface RadioGroupProps {
  value?: string | number;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  options?: Option[];
}

export const RadioGroup: React.FC<RadioGroupProps> = ({ value, onChange, options = [] }) => {
  return (
    <Box sx={{ p: 1 }}>
      <MuiRadioGroup
        value={value}
        onChange={(e) => onChange?.(e)}
        sx={{ display: 'flex', flexDirection: 'column' }}
      >
        {options.map((option) => (
          <FormControlLabel
            key={option.value}
            value={option.value}
            control={<Radio />}
            label={option.label}
            sx={{ m: '4px 0' }}
          />
        ))}
      </MuiRadioGroup>
    </Box>
  );
};
